import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import * as UserStore from '../../app/store/UserStore';
import UserDetails from './components/UserDetails';


const styles = theme => ({
    root: {

    },
    header: {
        display: 'flex',
    },
    flex: {
        flex: '1 1 auto',
    },
    action: {
        [theme.breakpoints.down('xs')]: {
            height: 30,
            minHeight: 30,
            width: 30,
        },
    },
});


class User extends React.Component {
    componentDidMount() {
        if (this.props.match.params.id && !this.props.userData) {
            this.props.getElement(this.props.match.params.id);
        }
    }

    render() {
        const { classes, userData } = this.props;

        if (!userData) {
            return null;
        }
        return (
            <div className={classes.root}>
                <UserDetails userData={userData} />
            </div>
        );
    }
}


User.propTypes = {
    classes: PropTypes.object.isRequired,
    // translate: PropTypes.func.isRequired,
    getElement: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    userData: PropTypes.object,
};

User.defaultProps = {
    userData: null,
};

const mapStateToProps = (state, ownProps) => ({
    translate: getTranslate(state.localize),
    userData: state.user.details && state.user.details[ownProps.match.params.id],
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(UserStore.actionCreators, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(User));
